import { t } from 'i18next'
import React from 'react'

const NoRecords = () => {
  return (
    <div className='w-full h-auto table-text text-center'>
        {t('lang_There_are_no_records_to_display')}
    </div>
  )
}

export default NoRecords